export const SET_PROFILE = 'SET_PROFILE';
export const SET_TOTAL_INCOME = 'SET_TOTAL_INCOME';
export const SET_FINANCIAL_STATS = 'SET_FINANCIAL_STATS';
export const SET_ALL_INCOMES = 'SET_ALL_INCOMES';
export const SET_BASE_CURRENCY = 'SET_BASE_CURRENCY';
export const SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL';
export const SET_SELECTED_INCOME = 'SET_SELECTED_INCOME';
